// The footer: the page-size menu, the live result count and the bottom pager,
// in that order. Below 768px the count drops under the other two
// (z6-me-table-pager.css); DOM and tab order stay the same.

import React from 'react'

import { Button, Menu } from '@CommonComponents/buttons'
import { useTable } from '../context'
import { ACTIONS } from '../types'
import { countText } from './countText'
import { groupedCountText } from '../grouped/copy'
import { Pager, useClearPageSelection } from './Pagers'

/** Positive whole sizes, once each, smallest first; never an "All" choice. */
export const pageSizeChoices = sizes =>
  Array.from(
    new Set((sizes || []).filter(size => Number.isInteger(size) && size > 0))
  ).sort((a, b) => a - b)

const PageSizeMenu = () => {
  const { config, state, dispatch } = useTable()
  const clearPageSelection = useClearPageSelection()
  const { text } = window.MEButtons
  return (
    <Menu
      label={text('strPageSize')}
      valueLabel={text('strPerPage', { size: state.pageSize })}
      className="me-btn me-btn-secondary me-btn-sm me-btn-menu-trigger"
    >
      {pageSizeChoices(config.pageSizes).map(size => (
        <Button
          key={size}
          className="me-menu-item"
          onClick={() => {
            if (size === state.pageSize) return
            dispatch({ type: ACTIONS.pageSizeSet, size, reason: 'pageSize' })
            clearPageSelection('pageSize')
          }}
        >
          {text('strPerPage', { size })}
        </Button>
      ))}
    </Menu>
  )
}

export const Footer = () => {
  const { config, status, derived } = useTable()
  // an unpaged table shows every row, so it has nothing to page or count
  if (derived.zeroData || config.paged === false) return null
  const count = (
    <div className="me-table-count" aria-live="polite" aria-atomic="true">
      {config.grouped
        ? groupedCountText(window.MEButtons.text, { status, ...derived })
        : countText(window.MEButtons.text, { status, ...derived })}
    </div>
  )
  // a grouped instance has no pages: its footer carries only the result count
  if (config.grouped)
    return <div className="me-table-footer is-count-only">{count}</div>
  return (
    <div className="me-table-footer">
      {!config.embedded && <PageSizeMenu />}
      {count}
      <Pager position="bottom" />
    </div>
  )
}
